import type { Card } from './types';

export const INITIAL_DECK_MIN_SIZE = 16;
export const REWARD_REMOVE_MIN_DECK_SIZE = 20;
export const REQUIRE_BOTH_KINDS = true;

export function getDeckRemoveBlockedReason(
  deck: Card[],
  card: Card | null | undefined,
  minDeckSize: number,
  requireBothKinds: boolean = REQUIRE_BOTH_KINDS
): string | null {
  if (!card) return 'Invalid card.';
  if (deck.length <= minDeckSize) return 'Your deck has the minimum size.';
  if (!requireBothKinds) return null;

  const phys = deck.filter((c) => c.kind === 'physical').length;
  const mag = deck.filter((c) => c.kind === 'magic').length;

  if (card.kind === 'physical' && phys <= 1) return 'You must keep at least 1 Physical card.';
  if (card.kind === 'magic' && mag <= 1) return 'You must keep at least 1 Magic card.';
  return null;
}

export function canRemoveDeckCard(
  deck: Card[],
  cardId: string,
  minDeckSize: number,
  requireBothKinds: boolean = REQUIRE_BOTH_KINDS
): boolean {
  const target = deck.find((c) => c.id === cardId);
  return !getDeckRemoveBlockedReason(deck, target, minDeckSize, requireBothKinds);
}
